import { Lightning } from "@lightningjs/sdk";
import { Base, TextBox, utils } from "@lightningjs/ui-components";
import { Helper } from "../../../helper";
import EPGConfig from "../epg-config";

export default class EPGRowLabelUI extends Base {
    static FixedPillWidth = 265;

    _isActive = false;
    _isFocused = false;
    _rowName = '';
    _isActiveRow = false;

    static override _template() {
        return {
            w: EPGConfig.RowLabelWidth,
            h: EPGConfig.RowLabelItemHeight,
            FocusBackground: {
                w: 0,
                h: 54,
                y: Math.floor(EPGConfig.RowLabelItemHeight / 2),
                mountY: 0.5,
                rect: true,
                color: 0x4DFFFFFF,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: 27,
                    stroke: 3,
                    strokeColor: 0xFFFFFFFF
                },
                visible: false
            },
            Label: {
                x: 20,
                y: Math.floor(EPGConfig.RowLabelItemHeight / 2)+1,
                mountY: 0.5,
                w: EPGConfig.RowLabelWidth,
                text: {
                    text: '',
                    fontSize: 22,
                    fontFace: Helper.getFontFamily('Black'),
                    textColor: 0x80FFFFFF,
                    wordWrapWidth: EPGConfig.RowLabelWidth,
                    maxLines: 1,
                    maxLinesSuffix: '...',
                    textAlign: 'left'
                }
            },
            HitArea: {
                x: 20,
                y: 0,
                w: EPGConfig.RowLabelWidth,
                h: EPGConfig.RowLabelItemHeight,
                rect: true,
                color: 0x00000000,
                collision: true,
                zIndex: 99,
            }
        };
    }

    static get __componentName(): string {
        return 'EPGRowLabelUI';
    }

    static get properties() {
        return ['rowName', 'isActiveRow'];
    }

    static get tags() {
        return ['Label', 'FocusBackground'];
    }

    _resizeFocusPill(fontFace: string, fontSize: number) {
        const paddingX = 20;
        const textWidth = utils.measureTextWidth({ text: this._rowName || '', fontFace, fontSize });
        const maxWidth = EPGConfig.RowLabelWidth + paddingX;
        const width = Math.min(Math.max(textWidth + paddingX * 2, EPGRowLabelUI.FixedPillWidth), maxWidth);
        (this.tag('FocusBackground') as any).w = width;
    }

    _update() {
        let textColor = 0x80FFFFFF;
        let fontFace = Helper.getFontFamily('Regular');
        let fontSize = 22;

        if (this._isFocused) {
            textColor = 0xFFFFFFFF;
            fontFace = Helper.getFontFamily('Black');
            fontSize = 25;
        } else if (this._isActiveRow) {
            textColor = 0xFFFFFFFF;
            fontFace = Helper.getFontFamily('Black');
            fontSize = 22;
        }

        this.tag('FocusBackground').visible = this._isFocused;
        if (this._isFocused) {
            this._resizeFocusPill(fontFace, fontSize);
        }

        this.tag('Label').patch({
            text: {
                text: this._rowName || '',
                textColor: textColor,
                fontFace: fontFace,
                fontSize: fontSize
            }
        });
    }

    override _active() {
        this._isActive = true;
        this._update();
    }

    override _inactive() {
        this._isActive = false;
        this._update();
    }

    override _focus() {
        this._isFocused = true;
        this._update();
    }

    override _unfocus() {
        this._isFocused = false;
        this._update();
    }

    _handleScroll(obj: any) {
        const direction = (obj && obj.wheelDeltaY > 0) ? 'up' : 'down'
        ;(this as any).fireAncestors('$rowLabelScrolled', direction)
        return true
    }

    _handleClick() {
        ;(this as any).fireAncestors('$rowLabelClicked', this._rowName)
        return true
    }
}
